module.exports = __webpack_public_path__ + "img/icon18.ca55d64d.png";